<template>
  <div class="active-creat">
    <div class="active-title">活动创建</div>
    <creatandEdit></creatandEdit>
  </div>
</template>

<script>
import creatandEdit from "./components/creatandEdit.vue";
export default {
  components: {
    creatandEdit,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
.active-creat {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* height: 100%; */
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #fff;
}
.active-title {
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
  margin-bottom: 100px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-form-item {
  margin-bottom: 10px;
}
</style>
